import { motion } from "framer-motion";
import { Compass, HandCoins, LockKey, ClockClockwise } from "@phosphor-icons/react";

const points = [
  {
    title: "Partner-led engagements",
    desc: "Senior chartered accountants own every file. No handoffs to interns.",
    icon: Compass,
  },
  {
    title: "Transparent, flat retainers",
    desc: "No clock-watching. Quoted retainers, documented scope, predictable bills.",
    icon: HandCoins,
  },
  {
    title: "Confidential by design",
    desc: "Restricted access, signed NDAs, segregated workspaces. Your books stay yours.",
    icon: LockKey,
  },
  {
    title: "On-time, every time",
    desc: "Statutory calendars are tracked weekly. We file ahead of deadlines, not against them.",
    icon: ClockClockwise,
  },
];

export default function WhyUs() {
  return (
    <section data-testid="why-section" className="py-24 md:py-32 bg-[#FDFBF7]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl mb-16">
          <div className="overline mb-5">/ Why Anand Aditya &amp; Co.</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl leading-tight text-[#1B3B2B]">
            The difference is in the discipline.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#D1CEC5] border border-[#D1CEC5]">
          {points.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.title}
                data-testid={`why-card-${i}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-[#FDFBF7] p-10 hover:bg-[#F3F0EA] transition-colors duration-300"
              >
                <Icon size={30} weight="duotone" className="text-[#1B3B2B]" />
                <div className="overline mt-8 text-[10px]">{String(i + 1).padStart(2, "0")}</div>
                <h3 className="font-serif-display text-2xl mt-3 text-[#1B3B2B] leading-snug">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm text-[#4A5D53] leading-relaxed">{p.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
